// extracted by css-extract-rspack-plugin
export default {"inputRow":"inputRow-zCl342","inputActions":"inputActions-KfPDBo"};